import { axiosToken, simpleAxios } from "@/utils/http";
import type { AxiosResponse } from "axios";
import type { List } from "lodash";
import { defineStore, acceptHMRUpdate } from "pinia"
import { useTapasStore } from "./tapas";
import type { TapasChallenge } from "./interfaces/tapas_interfaces";
import { translate, translateAll } from "@/utils/translate";
import { initDB , checkImageDb} from "@/utils/indexeddb";
type Challenge = {
	id: number, 
	name: string, 
	name_es: string | null,
	name_en: string | null,
	name_lang1: string | null,
	name_lang2: string | null,
	name_lang3: string | null,
	description: string, 
	image: string, 
	material: string, 
	scoring_description: string,
	material_es: string | null,
	material_en: string | null,
	material_lang1: string | null,
	material_lang2: string | null,
	material_lang3: string | null,
	description_es: string | null,
	description_en: string | null,
	description_lang1: string | null,
	description_lang2: string | null,
	description_lang3: string | null,
	scoring_description_es: string | null,
	scoring_description_en: string | null,
	scoring_description_lang1: string | null,
	scoring_description_lang2: string | null,
	scoring_description_lang3: string | null,
}

export const useContentStore = defineStore("content", {
	state: () => ({
		fileToUpload:{}, // USED IN FORMGENERATOR TO SAVE THE IMAGE THAT HAVE TO BE UPLOADED OR DELETED
		showAlertUnSaved:false, // USED IN FORMGENERATOR TO SHOW UNSUED CHANGED
		loadingBtnForm:false,
		activities: [],
        challenges: [],
		content: {},
		jsonTableFK:{},
		totalContentToDownload:0,
		currentContentDownloaded:0,
		/** True while the event content HTTP request is in flight (before totals are known). */
		eventContentFetchPending: false,
		/** Second-phase downloads (e.g. iPad Hunt IndexedDB challenge bundles); player + instructor. */
		assetCacheDownloadVisible: false,
		assetCacheDownloadCurrent: 0,
		assetCacheDownloadTotal: 0,
		/** True after offline-cache prep starts until challenge list is known (avoids dialog closing between event content and asset phases). */
		assetCacheListFetchPending: false,
		/**
		 * iPad Hunt: keep download overlay visible after event content finishes until
		 * offline challenge cache completes (single modal; only copy/progress change).
		 */
		sequentialContentDownloadPipeline: false,
	}),
	actions: {
		async setDefault()
		{
			this.fileToUpload = {} // USED IN FORMGENERATOR TO SAVE THE IMAGE THAT HAVE TO BE UPLOADED OR DELETED
			this.showAlertUnSaved = false // USED IN FORMGENERATOR TO SHOW UNSUED CHANGED
			this.loadingBtnForm = false
			this.activities = []
			this.challenges = []
			this.content = {}
			this.jsonTableFK = {}
			this.totalContentToDownload = 0
			this.currentContentDownloaded = 0
			this.eventContentFetchPending = false
			this.assetCacheDownloadVisible = false
			this.assetCacheDownloadCurrent = 0
			this.assetCacheDownloadTotal = 0
			this.assetCacheListFetchPending = false
			this.sequentialContentDownloadPipeline = false
		},
		/** Call before getContentByEvent when a second save phase follows (e.g. iPad Hunt). */
		startSequentialContentDownloadPipeline() {
			this.sequentialContentDownloadPipeline = true
		},
		startAssetCacheDownload(total: number) {
			this.assetCacheListFetchPending = false
			this.assetCacheDownloadCurrent = 0
			this.assetCacheDownloadTotal = total
			if (total === 0) {
				this.assetCacheDownloadVisible = false
				return
			}
			this.assetCacheDownloadVisible = true
		},
		incrementAssetCacheDownload() {
			this.assetCacheDownloadCurrent++
		},
		endAssetCacheDownload() {
			this.assetCacheDownloadVisible = false
			this.assetCacheListFetchPending = false
			this.sequentialContentDownloadPipeline = false
			this.assetCacheDownloadCurrent = 0
			this.assetCacheDownloadTotal = 0
		},
		beginAssetCacheListFetch() {
			this.assetCacheListFetchPending = true
		},
		async getActivities ()
		{
			await axiosToken("get", "events/activity/", {})
			.then((response: AxiosResponse) => {
				this.activities = response.data
			})
			.catch((e: any) => {
				console.log(e);
			});
		},
		async getContentByEvent(event_api_key: string, download_images:boolean = true)
		{
			this.eventContentFetchPending = true
			this.totalContentToDownload = 0
			this.currentContentDownloaded = 0
			try {
				await simpleAxios("get", "content/get_content_event/" + event_api_key + "/" , {})
					.then(async (response: AxiosResponse) => {
						this.totalContentToDownload = 0;
						this.currentContentDownloaded = 0;
						for (const content in response.data) {
							this.totalContentToDownload += response.data[content].length
						}
						for (const content in response.data) {
							const data = response.data[content]
							this.content[content] = data
							// only check if url is for player or event
							if(download_images)	
							{
								for (let index = 0; index < data.length; index++) {
									this.currentContentDownloaded ++;
									await checkImageDb(content, data[index])
								}
							}

						}
						if (!download_images && this.totalContentToDownload > 0) {
							this.currentContentDownloaded = this.totalContentToDownload
						}
					});
			} catch (e: any) {
				console.log(e);
			} finally {
				this.eventContentFetchPending = false
			}
		},
		async getAllMultipleContent(names:Array<string>)
		{
			console.log(names);
			
			const promises = names.map(name => this.getAllContent(name));
			await Promise.all(promises);
		},
		async getAllContent(name:string)
		{
			await axiosToken("get", "content/gateway/" + name + "/", {})
			.then(async (response: AxiosResponse) => {
				const data = response.data.sort((a, b) => b.id - a.id);
				this.content[name] = data
				// DONWLOAD AND SAVE THE DATA
				const fetchData = data;
				console.log(fetchData);
				

				// NO NEED TO DOWNLOAD IN TH EMAIN APP 
				// for (let index = 0; index < fetchData.length; index++) {
				// 	checkImageDb(name, fetchData[index])
				// }
				// check if image exist and is in database
				
				
				
			})
			.catch((e: any) => {
				console.log(e);
			});
		},
		async getContentByIds(name:string, id:Array)
		{
			await axiosToken("get", "content/gateway/" + name + "/", {id})
			.then(async (response: AxiosResponse) => {
				this.content[name] = response.data
			})
			.catch((e: any) => {
				console.log(e);
			});
		},
		async getSimpleContent(name:string, id:number)
		{
			await axiosToken("get", "content/gateway/" + name + "/" + id , {})
			.then(async (response: AxiosResponse) => {
				if( this.content.hasOwnProperty(name))
				{
					this.content[name].push(response.data)
				}
				else
				{
					this.content[name] = [response.data]

				}
				// DONWLOAD AND SAVE THE DATA
				const fetchData = response.data;
				console.log(fetchData);
				
				checkImageDb(name, fetchData)
				// check if image exist and is in database
				
				
				
			})
			.catch((e: any) => {
				console.log(e);
			});
		},
		async getMediaByApiKey(apiKey:string)
		{
			await simpleAxios("get", "content/media/" + apiKey + "/", {})
			.then(async (response: AxiosResponse) => {
				const name = "media"
				if( Object.prototype.hasOwnProperty.call(this.content, name))
				{
					// Check if media already exists to avoid duplicates
					const exists = this.content[name].find((m: any) => m.uuid === apiKey || m.id === response.data.id)
					if(!exists)
					{
						this.content[name].push(response.data)
					}
				}
				else
				{
					this.content[name] = [response.data]
				}
				// DONWLOAD AND SAVE THE DATA
				const fetchData = response.data;
				console.log(fetchData);
				
				checkImageDb(name, fetchData)
				// check if image exist and is in database
			})
			.catch((e: any) => {
				console.log(e);
			});
		},
		async deleteContentById(name:string, id:number)
		{
			return await axiosToken("delete", "content/gateway/" + name + "/" + id , {})
		},
		async updateContentById(name:string, id:number, data:object)
		{
			return await axiosToken("put", "content/gateway/" + name + "/" + id , data)
		},
		async newContentById(name:string, data:object, save_id:boolean = false)
		{
			const response = await axiosToken("post", "content/gateway/" + name + "/"  , data)
			if(save_id)
			{
				data.id = response.data.id
			}
			return response
		},
		async fetchGatewayFind (name:string, id:string | string[], type:string)
		{
			const returnData = await axiosToken("get", "content/gateway_find/" + name + "/?" + type + '=' + id)
			return returnData.data
		},
	},
	persist: {
		// paths: ["events"]
	},
	getters:{

		// challenges
		
		// ingridients
		getContentIngridient: state => (id:number): any | undefined  =>{
			if  (!( 'ingredient' in state.content))
			{
				return {};
			}
			else
			{
				const ingredient = translate(state.content.ingredient.find(e => e.id == id), ["name", "description"])
				return ingredient;
			}
		},
		getContentIngridients: state => () => {
			if  (!( 'ingredient' in state.content))
			{
				return {};
			}
			else
			{
				const ingredients = translateAll(state.content.ingredient, ["name", "description"])
				return ingredients;
			}
		},
		getContentCards: state => (id:number): any | undefined  =>{
			if  (!( 'card' in state.content))
			{
				return {};
			}
			else
			{
				return state.content.card.find(e => e.id == id);
			}
		},
		getItemShop: state => (id:number): any | undefined  =>{
			if  (!( 'item_shop' in state.content))
			{
				return {};
			}
			else
			{
				const item_shop = translate(state.content.item_shop.find(e => e.id == id), ["name", "description"])
				return item_shop;
			}
		}, 
		getItemsShop: state => () => {
			if  (!( 'item_shop' in state.content))
			{
				return {};
			}
			else
			{
				const items_shop = translateAll(state.content.item_shop, ["name", "description"])
				return items_shop;
			}
		},
		getContentByTypeById: state => (type:String, id:number): any | undefined  =>{
			return state.content[type].find(e=> e.id == id)
		},
		getContentActionChallenge: state => (id:number): any | undefined  =>{
			if  (!( 'action_challenge_challenge' in state.content))
			{
				return {};
			}
			else
			{
				const challenge = translate(state.content.action_challenge_challenge.find(e => e.id == id), ["name", "description", "short_description"])
				return challenge;
			}
		},
		getChallengesOptions: state => () =>
		{
			if  (!( 'action_challenge_challenge' in state.content))
			{
				return {};
			}
			else
			{
				const challenge = state.content.action_challenge_challenge.map((v) => {
					const translatedChallenge = translate(v, ["name"])
					return {
						value: v.id.toString(),
						label: translatedChallenge?.name || v.name,
					}
				})
				return challenge;
			}
		},
		getContentActionCategory: state => (id:number): any | undefined  =>{
			if  (!( 'category_quiz' in state.content))
			{
				return {};
			}
			else
			{
				const category = translate(state.content.category_quiz.find(e => e.id == id), ["name"])
				return category;
			}
		},
		getContentBookingQuestion: state => (activities:number[]): any | undefined  =>{
			if  (!( 'bookingQuestion' in state.content))
			{
				return [];
			}
			else
			{
				if(activities.length > 0)
				{
					const returnItems:any = []
					state.content.bookingQuestion.forEach(e => {
						if(activities.includes(e.id))
						{
							returnItems.push(e)
						}
					});
					console.log(returnItems);
					
					return returnItems
				}
				else
				{
					return state.content.bookingQuestion
				}
			}
		},
		getUserProfile: state => (role:string): any | undefined  =>{
			if  (!( 'userProfile' in state.content))
			{
				return [];
			}
			else
			{
				if(role != null || role != undefined)
				{
					return state.content.userProfile.filter(e => e.rol == role)
				}
				else
				{
					return state.content.userProfile
				}
			}
		},
		getActivity: state => (id:number): any | undefined  =>{
			if  (!( 'activity' in state.content))
			{
				return {};
			}
			else
			{
				return state.content.activity.find(e => e.id == id);
			}
		},
		getClient: state => (id:number): any | undefined => {
			if  (!( 'client' in state.content))
			{
				return {};
			}
			else
			{
				return state.content.client.find(e => e.id == id);
			}
		},
		/** True while getContentByEvent is saving assets to IndexedDB (player flow). */
		isEventContentDownloading(state): boolean {
			return (
				state.totalContentToDownload > 0 &&
				state.currentContentDownloaded < state.totalContentToDownload
			);
		},
		isAssetCacheDownloading(state): boolean {
			return state.assetCacheDownloadVisible === true;
		},
		/** Player + instructor shell: one overlay for event images + offline asset prep without flashing closed. */
		isContentDownloadOverlayVisible(state): boolean {
			return (
				state.eventContentFetchPending ||
				(state.totalContentToDownload > 0 &&
					state.currentContentDownloaded < state.totalContentToDownload) ||
				state.assetCacheDownloadVisible ||
				state.assetCacheListFetchPending ||
				state.sequentialContentDownloadPipeline
			);
		},

	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useContentStore, import.meta.hot))
}
